import React, { PropTypes } from "react"
import { Row, Col } from "react-bootstrap"
import { Button } from "antd"
import Classnames from "classnames"
import numeral from "numeral"
import "./Plan.css"
export default class Plan extends React.Component {
  constructor(props) {
    super(props)
  }

  handleOnSelect() {
    const { productIdentifier, price, interval } = this.props
    this.props.onSelect(productIdentifier, price, interval)
  }

  render() {
    const props = this.props

    return props.isGroup ? (
      <div className="Plan">
        <div>
          {this.props.save && <p className="saveLabel">{this.props.save}</p>}
          <div className="plan-name">{props.planName}</div>
          <div className="quantity">
            <span className="dollar">$</span>
            <span className="price">
              {numeral(props.price).format("0,0[.]00")}
            </span>

            <div>
              <span style={{ fontSize: "14px", lineHeight: 3 }}>
                {props.label}
              </span>
            </div>
          </div>
          <Button type="primary" onClick={this.handleOnSelect.bind(this)}>
            {props.buttonText}
          </Button>
        </div>
      </div>
    ) : (
      <div className="Plan">
        <div>
          {this.props.save && <p className="saveLabel">{this.props.save}</p>}
          <div className="plan-name">{props.planName}</div>
          <div className="quantity">
            <span className="dollar">$</span>
            <span className="price">
              {numeral(props.displayPrice).format("0,0[.]00")}
            </span>
            <span className="period">/ {props.interval}</span>

            <div>
              <hr />
              <span style={{ fontSize: "14px", lineHeight: 3 }}>
                {props.billedAsLabel}
              </span>
            </div>
          </div>
          <div className="specs" />
          <Button type="primary" onClick={this.handleOnSelect.bind(this)}>
            {props.buttonText}
          </Button>
        </div>
      </div>
    )
  }
}

Plan.propTypes = {}



// WEBPACK FOOTER //
// ./src/subscriptions/Plan.js